/**
 * Ortssuche über Nominatim (OSM). Für Produktion mit eigener Instanz oder
 * einem Geocoder mit Nutzungsvertrag ersetzen – siehe README.
 */
const ENDPOINT = 'https://nominatim.openstreetmap.org/search';

/** Einzelnes Suchergebnis zu einem freien Text – fuer die Routenfelder. */
export async function geocode(query, map) {
  const b = map.getBounds();
  const params = new URLSearchParams({
    q: query,
    format: 'jsonv2',
    limit: '1',
    'accept-language': 'de-CH',
    viewbox: [b.getWest(), b.getNorth(), b.getEast(), b.getSouth()].join(','),
    bounded: '0'
  });
  const res = await fetch(`${ENDPOINT}?${params}`, { headers: { Accept: 'application/json' } });
  if (!res.ok) throw new Error('Ortssuche nicht erreichbar.');
  const [hit] = await res.json();
  if (!hit) throw new Error(`"${query}" nicht gefunden.`);
  return { lat: Number(hit.lat), lng: Number(hit.lon), name: hit.name || hit.display_name.split(', ')[0] };
}

export function createSearchBox({ map, input, clearBtn, resultList, onPick }) {
  let timer;
  let controller;
  let items = [];

  const hide = () => {
    resultList.hidden = true;
    resultList.textContent = '';
    items = [];
  };

  function render(list) {
    resultList.textContent = '';
    if (!list.length) {
      const li = document.createElement('li');
      li.className = 'is-empty';
      li.textContent = 'Nichts gefunden.';
      resultList.append(li);
      resultList.hidden = false;
      return;
    }
    list.forEach((r, i) => {
      const li = document.createElement('li');
      const btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('role', 'option');
      btn.dataset.index = String(i);
      const [head, ...rest] = r.display_name.split(', ');
      btn.innerHTML = `<strong></strong><small></small>`;
      btn.querySelector('strong').textContent = r.name || head;
      btn.querySelector('small').textContent = rest.join(', ');
      btn.addEventListener('click', () => pick(r));
      li.append(btn);
      resultList.append(li);
    });
    resultList.hidden = false;
  }

  function pick(r) {
    const lat = Number(r.lat);
    const lng = Number(r.lon);
    if (r.boundingbox) {
      const [s, n, w, e] = r.boundingbox.map(Number);
      map.fitBounds([[w, s], [e, n]], { padding: 60, maxZoom: 17, duration: 800 });
    } else {
      map.flyTo({ center: [lng, lat], zoom: 16, duration: 800 });
    }
    input.value = r.name || r.display_name.split(', ')[0];
    hide();
    onPick?.({ name: input.value, lat, lng, display: r.display_name });
  }

  async function run(q) {
    controller?.abort();
    controller = new AbortController();
    const b = map.getBounds();
    const params = new URLSearchParams({
      q,
      format: 'jsonv2',
      limit: '8',
      addressdetails: '0',
      'accept-language': 'de-CH',
      viewbox: [b.getWest(), b.getNorth(), b.getEast(), b.getSouth()].join(','),
      bounded: '0'
    });
    try {
      const res = await fetch(`${ENDPOINT}?${params}`, {
        signal: controller.signal,
        headers: { Accept: 'application/json' }
      });
      if (!res.ok) throw new Error(String(res.status));
      items = await res.json();
      render(items);
    } catch (err) {
      if (err.name !== 'AbortError') hide();
    }
  }

  input.addEventListener('input', () => {
    const q = input.value.trim();
    clearBtn.hidden = !q;
    clearTimeout(timer);
    if (q.length < 3) return hide();
    timer = setTimeout(() => run(q), 400);
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { hide(); input.blur(); }
    if (e.key === 'Enter' && items.length) { e.preventDefault(); pick(items[0]); }
    if (e.key === 'ArrowDown') {
      e.preventDefault();
      resultList.querySelector('button')?.focus();
    }
  });

  clearBtn.addEventListener('click', () => {
    input.value = '';
    clearBtn.hidden = true;
    hide();
    input.focus();
  });

  document.addEventListener('click', (e) => {
    if (!resultList.hidden && !e.target.closest('.search')) hide();
  });

  return { hide };
}
